// extracted by mini-css-extract-plugin
export default {"open_content":"Open_open_content_eqo3t","open_content_body":"Open_open_content_body_tb9C3"};